import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const SectionBox = styled(Box)`
  && {
    margin-top: 2rem;
    h6 {
      color: ${({ theme }) => theme.secondaryColor[600]};
      font-weight: 700;
    }
  }
`;

export const ApplicationMeta = styled(Typography).attrs((props) => ({
    variant: props.variant || 'body1',
}))`
  && {
    line-height: 1;
    align-items: center;
    display: flex;
    margin: 1rem 0;
    color: ${({ theme }) => theme.secondaryColor[700]};
  }

  svg {
    font-size: 1.2rem;
    margin-right: 0.2rem;
  }
`;